import React from 'react';
import styled from 'styled-components';
import { motion } from 'framer-motion';
import { theme } from '../utils/theme';
import { device } from '../utils/mediaQueries';

const AboutSection = styled.section`
  min-height: 100vh;
  padding: 80px 20px;
  background: ${theme.background};
  color: ${theme.text};
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;

  ${device.tablet} {
    padding: 100px 40px;
  }

  ${device.laptop} {
    padding: 120px 60px;
  }
`;

const Container = styled.div`
  max-width: 750px;
  width: 100%;
  margin: 0 auto;
  text-align: center;
`;

const SectionTitle = styled(motion.h2)`
  font-size: clamp(1.75rem, 5vw, 3rem);
  margin-bottom: 1rem;
  color: ${theme.white};
  font-weight: 700;
  letter-spacing: -0.02em;
`;

const Subtitle = styled(motion.p)`
  color: ${theme.secondary};
  font-family: ${theme.fontMono};
  font-size: 0.9rem;
  margin-bottom: 2rem;
  letter-spacing: 0.05em;
  
  ${device.tablet} {
    font-size: 1rem;
    margin-bottom: 2.5rem;
  }
`;

const ProfileImage = styled(motion.div)`
  width: 130px;
  height: 130px;
  margin: 0 auto 2rem;
  border-radius: 50%;
  overflow: hidden;
  border: 3px solid rgba(255, 255, 255, 0.15);
  transition: ${theme.transition};

  &:hover {
    transform: scale(1.05);
    border-color: rgba(255, 255, 255, 0.3);
  }

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }

  ${device.tablet} {
    width: 180px;
    height: 180px;
    margin-bottom: 2.5rem;
    border-width: 4px;
  }
`;

const Bio = styled(motion.div)`
  font-size: 0.95rem;
  line-height: 1.8;
  color: ${theme.text};
  max-width: 650px;
  margin: 0 auto;
  text-align: left;

  p {
    margin-bottom: 1.25rem;

    &:last-child {
      margin-bottom: 0;
    }
  }

  strong {
    color: ${theme.white};
    font-weight: 600;
  }

  ${device.tablet} {
    font-size: 1.05rem;
  }
`;

const About = () => {
  return (
    <AboutSection id="about">
      <Container>
        <Subtitle
          data-aos="fade-up"
        >
          Get to know me
        </Subtitle>
        <SectionTitle
          data-aos="fade-up"
          data-aos-delay="100"
        >
          About Me
        </SectionTitle>

        <ProfileImage
          data-aos="zoom-in"
          data-aos-delay="200"
        >
          <img
            src="/images/profile.jpeg"
            alt="Gokulakannan - Full Stack AI Developer"
          />
        </ProfileImage>

        <Bio
          data-aos="fade-up"
          data-aos-delay="300"
        >
          <p>

Hi, I'm Gokulakannan, a passionate Full-Stack AI Developer with a strong interest in building modern, scalable, and intelligent web applications. I earned my B.Tech in Information Technology from Anna University, where I developed a solid foundation in software engineering and problem-solving.

My expertise includes React.js for dynamic front-end development, Node.js for robust back-end services, and AI integration using technologies such as Google Gemini and Machine Learning. I enjoy creating efficient, user-centric applications that solve real-world challenges.

I am committed to continuous learning, staying up to date with emerging technologies, and improving my technical skills. I look forward to collaborating with innovative teams and contributing to impactful software solutions that deliver meaningful value.

          </p>
        </Bio>
      </Container>
    </AboutSection>
  );
};

export default About;